<template>
  <div class="w-100">
    <div class="hero__banner">
      <b-col
        cols="12"
        class="hero__bg pt-5 px-3 px-md-0 d-flex justify-content-left"
        :style="{ backgroundImage: `url('/congress/img/events/${eventId}/hero-bg.png?v=${version}')` }"
      >
        <div class="eventInfo mr-auto">
          <div>
            <img :src="`${publicPath}img/events/${eventId}/logo.png?v=${this.appVersion}`" class="navbar-logo" alt="Congress Logo" />
          </div>
          <h1>Simulation village</h1>
        </div>
        <div class="pt-5 mr-4">
          <b-button pill class="btn-congress border-0" :href="`simulation-village-host-admin?password=${password}`">Admin</b-button>
        </div>
      </b-col>
    </div>
    <div v-if="!isLoading">
      <b-container fluid class="px-lg-5" v-if="!displayError">
        <b-row no-gutters v-if="workshops.length">
          <b-col cols="12" md="6" lg="4" xl="3" class="card-deck pb-2 pb-md-4 px-0 mx-0" v-for="workshop in workshops" :key="workshop.id">
            <b-card :title="workshop.displayName" class="session__card">
              <template #header>
                <div class="pb-2">
                  <div class="session__time font-bold d-block">
                    {{ workshop.date | formatUnixEpocDayPart }} • {{ workshop.startTime | formatTime }} -
                    {{ workshop.endTime | formatTime }}
                  </div>
                  <div class="session__time font-bold d-block">
                    {{ workshop.roomName }}
                  </div>
                </div>
              </template>
              <b-card-text>
                <b-list-group>
                  <b-list-group-item v-for="contact in workshop.contacts" :key="contact.ESCID">
                    {{ contact.name }}
                  </b-list-group-item>
                </b-list-group>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <b-alert :show="workshops.length == 0" variant="congress">
          <font-awesome-icon icon="info-circle" size="lg" class="alert_icon la-t-plus-1 mr-2 float-left" />
          There are currently no workshop sessions taking place.
        </b-alert>
      </b-container>
      <b-container v-else>
        <AccessDeniedBlock />
      </b-container>
    </div>
    <div v-else>
      <b-container fluid class="px-lg-5">
        <div v-if="isLoading" class="d-flex justify-content-center m-5">
          <b-spinner style="width: 2rem; height: 2rem" variant="congress" label="loading"></b-spinner>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import { MediaApiService } from 'src/services/media-api';
  import AccessDeniedBlock from 'src/components/Blocks/AccessDeniedBlock.vue';

  export default {
    name: 'SimulationVillage',
    components: {
      AccessDeniedBlock,
    },
    computed: {
      publicPath() {
        return process.env.BASE_URL;
      },
      ...mapGetters(['isLogged', 'currentUser']),
      ...mapState({
        eventId: (state) => state.app.eventId,
        startDate: (state) => state.app.eventStartDate,
        endDate: (state) => state.app.eventEndDate,
        version: (state) => state.app.version,
        appVersion: (state) => state.app.version,
      }),
    },
    data() {
      return {
        workshops: [],
        intervalId: null,
        timeoutId: null,
        isLoading: true,
        password: null,
        displayError: false,
      };
    },
    async mounted() {
      this.getQueryPassword();
      await this.fetchWorkshopData();

      this.intervalId = setInterval(() => {
        this.timeoutId = setTimeout(async () => {
          await this.fetchWorkshopData();
        }, 5000);
      }, 60000);
    },
    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    },
    methods: {
      async fetchWorkshopData() {
        this.isLoading = true;
        MediaApiService.getCurrentWorkshopSesssions(this.eventId, this.password).then(async ({ data }) => {
          this.workshops = data.data;
          this.displayError = !data.success;

          this.isLoading = false;
        });
      },
      getQueryPassword() {
        this.password = this.$route.query.password;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/styles/theme';
  @import '~@/styles/theme';
  @import 'node_modules/bootstrap/scss/_functions';
  @import 'node_modules/bootstrap/scss/_variables';
  @import 'node_modules/bootstrap/scss/mixins/_breakpoints';

  .signIn__card {
    background: var(--congress);
    border-radius: 2rem;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    color: #fff;
    overflow: hidden;
  }

  .rounded-line {
    border-radius: 9999px;
    border: 1px solid var(--congress-light);
    transform: translate(50%, -50%);
  }

  .session__card-disabled {
    background-color: #fff;
    opacity: 0.4;
  }

  .session__card .btn-light:hover,
  .session__card .btn-light:active,
  .session__card .btn-light:focus {
    background-color: var(--congress-lighter) !important;
    color: var(--congress);
  }

  .btn-congress:hover,
  .btn-congress:active,
  .btn-congress:focus {
    background-color: var(--congress) !important;
    color: #fff;
  }

  .btn-light.disabled,
  .btn-light.disabled:hover {
    background-color: #f1f1f1 !important;
    color: #212529;
  }

  .session__card-disabled .btn-light.disabled:hover {
    background-color: #f1f1f1 !important;
    color: #212529;
  }

  ::v-deep .cart__card {
    background: #fff;
    border-radius: 2rem;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    color: #000;
    .cart__element {
      .dotted__separator {
        border-bottom: 2px dotted #e5e5e5;
        :last-of-type {
          border-bottom: 0 !important;
        }
      }
    }
  }

  .grey__text {
    color: #5f6368;
  }

  .list-group {
    background: #f3f6f7;
    border-radius: 20px;
    .list-group-item {
      font-size: 0.9rem;
      border: 0;
      border-bottom: 1px dotted rgba(0, 0, 0, 0.125);
      background: transparent;
    }
  }
  .list-group-item:last-child {
    border-bottom: 0;
  }

  .form-inline .form-control {
    min-width: 300px;
  }
</style>
